export default async function sequentialPromise(iterable, action) {
  for (const element of iterable) {
    // oxlint-disable-next-line no-await-in-loop
    await action(element);
  }
}
